module.exports = __webpack_public_path__ + "static/media/no-results-auto.c6252765.jpg";